module.exports = __webpack_public_path__ + "img/4064006990.32699297.jpg";